import { render, staticRenderFns } from "./site-view-units-selector.vue?vue&type=template&id=013cca0c&scoped=true"
import script from "./site-view-units-selector.vue?vue&type=script&lang=ts"
export * from "./site-view-units-selector.vue?vue&type=script&lang=ts"
import style0 from "./site-view-units-selector.vue?vue&type=style&index=0&id=013cca0c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013cca0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013cca0c')) {
      api.createRecord('013cca0c', component.options)
    } else {
      api.reload('013cca0c', component.options)
    }
    module.hot.accept("./site-view-units-selector.vue?vue&type=template&id=013cca0c&scoped=true", function () {
      api.rerender('013cca0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/results/site-view/site-view-units-selector.vue"
export default component.exports